module.exports = __webpack_public_path__ + "static/Sequence_Manifest_Homepage-fad3552863c57536726a2db9d9f23db0.mp4";